import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const params = new URLSearchParams(hash.replace(/^#/, ""));
    const session_id = params.get("session_id");
    if (!session_id) {
      navigate("/", { replace: true });
      return;
    }
    (async () => {
      try {
        let ref = null;
        let pendingJoin = null;
        try {
          ref = localStorage.getItem("pfo_ref");
          pendingJoin = localStorage.getItem("pfo_join");
        } catch (err) { console.debug("AuthCallback: localStorage unavailable", err); }
        const payload = { session_id };
        if (ref) payload.ref = ref;
        const { data } = await api.post("/auth/session", payload);
        try { localStorage.removeItem("pfo_ref"); } catch (err) { console.debug("AuthCallback: pfo_ref cleanup failed", err); }
        // /auth/session returns the user WITHOUT `is_admin` (that's
        // only computed by /auth/me). Hit /auth/me immediately so the
        // React state has is_admin correct from first render — avoids
        // admin sidebar disappearing after OAuth login until the next
        // hard refresh.
        try {
          const me = await api.get("/auth/me");
          setUser(me.data);
        } catch (err) {
          console.debug("AuthCallback: /auth/me refresh failed, falling back to session user", err);
          setUser(data.user);
        }
        // Auto-seed demo data ONLY for genuinely new users (first-time
        // signup). If we seeded on every login the "Reset my account"
        // flow in Settings would immediately repopulate on next login.
        if (data.is_new_user === true) {
          try { await api.post("/demo/seed"); } catch (err) { console.debug("AuthCallback: demo seed skipped", err); }
        }
        // If landing captured a circle join code, land on /circles which will auto-open the join modal
        const nextRoute = pendingJoin ? "/circles" : "/dashboard";
        navigate(nextRoute, { replace: true, state: { user: data.user } });
      } catch (e) {
        console.error("Session exchange failed", e);
        navigate("/", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[var(--bg-primary)]">
      <div className="text-center">
        <div className="text-[var(--text-muted)] text-sm tracking-[0.22em] uppercase">Signing you in</div>
        <div className="mt-3 num-md text-[var(--accent-primary)]">…</div>
      </div>
    </div>
  );
}
